import { useIsAreasAdminBoolean } from 'helpers/hooks/useIsAreasAdmin';
import {
  IconLayoutDashboard,
  IconUsers,
  IconUsersPlus,
  IconUserPlus,
  IconPremiumRights,
  IconFileDollar,
  IconBuildingStore,
  IconCash,
  IconFileInvoice,
  IconUpload,
  IconForms,
  IconReportMoney,
  IconMailForward,
  IconTags,
  IconListDetails,
  IconBuilding,
  IconClipboardData,
  IconMathMaxMin,
  IconGiftCard,
  IconReceipt2,
  IconList,
} from '@tabler/icons-react';
import {
  OPERATIONS,
  COMMERCIAL,
  CLIENT,
  CUSTOMER_SUPPORT,
  PRODUCT,
  ALL_ROLES,
  OPERATIONS_ANALYST,
  CLIENT_ANALYST,
  PRODUCT_ANALYST,
  SUPER_ADMIN,
  TECH,
  OPERATIONS_SUPERVISOR,
  CUSTOMER_SUPPORT_ANALYST,
  CORPORATE_CLIENT,
  INFRA,
} from '@globalConstants';
import {
  useShowMenuByCategories,
  useShowMenuByCategoriesAndProduct,
  useShowMenuByCorporateProduct,
} from '@hooks';
import AddClient from './addClients';
import AddCustomerProduct from './addCustomerProduct';
import AddSegments from './addSegments';
import ClientsScreen from './clients';
import ClientsAdjustmentScreen from './clients/adjustmentDetails';
import CommercesAdminScreen from './commercesAdmin';
import ConsolidatedDispersionsList from './consolidatedDispersionsList';
import ConsumptionByCategory from './consumptionByCategory';
import ConsumptionByCommerce from './consumptionByCommerce';
import ConsumptionList from './consumptionList';
import { DispersionDetails, FileDispersionsScreen, MyDispersionsScreen } from './dispersions';
import EmployeeDetailsScreen from './employeeDetails';
import EmployeesListScreen from './employeesList';
import ExchangeRatesScreen from './exchangeRates';
import HelpScreen from './help';
import HomeScreen from './home';
import Invoices from './invoices';
import LimitDetailScreen from './limitDetail';
import LimitsManagement from './limitsManagement';
import LoginScreen from './login';
import MovementDetails from './movementDetails';
import MyBalance from './myBalance';
import NamelessCardsScreen from './namelessCards';
import NamelessCardsListScreen from './namelessCardsList';
import NamelessCardBulkDetailScreen from './namelessCardsList/detail';
import PendingCustomersScreen from './pendingCustomers';
import PendingCustomerDetailScreen from './pendingCustomers/detail';
import PendingDispersionsScreen from './pendingDispersions';
import PendingDispersionDetailScreen from './pendingDispersions/detail';
import PendingProspectsScreen from './pendingProspects';
import PendingProspectDetailScreen from './pendingProspects/detail';
import ProspectCreationScreen from './prospectCreation';
import ProspectSendEmail from './prospectSendMail';
import ProspectUploadScreen from './prospectUpload';
import ReportDetails from './reportDetails';
import { TransferReceiptScreen } from './transferReceipt';
import CreateUserFormScreen from './userManagementForm';
import UsersManagment from './usersManagment';
export { default as SelectCompany } from './selectCompany';
export { default as LoadingScreen } from './loading';

const screens = [
  {
    path: '/',
    onMenu: true,
    title: 'Inicio',
    roles: ALL_ROLES,
    component: HomeScreen,
    icon: IconLayoutDashboard,
  },
  {
    path: '/ayuda',
    onMenu: false,
    title: 'Ayuda',
    roles: ALL_ROLES,
    component: HelpScreen,
  },
  { path: '/login', onMenu: false, roles: false, component: LoginScreen },
  {
    title: 'MENU:CLIENTS',
    path: '/clientes',
    icon: IconUsers,
    onMenu: true,
    roles: [
      PRODUCT,
      PRODUCT_ANALYST,
      OPERATIONS_ANALYST,
      CUSTOMER_SUPPORT,
      CUSTOMER_SUPPORT_ANALYST,
      OPERATIONS,
      COMMERCIAL,
      SUPER_ADMIN,
      TECH,
      OPERATIONS_SUPERVISOR,
    ],
    component: ClientsScreen,
  },
  {
    title: 'Detalles del ajuste',
    path: '/clientes/detalle-ajuste/:adjustmentId',
    onMenu: false,
    roles: [
      PRODUCT,
      PRODUCT_ANALYST,
      OPERATIONS_ANALYST,
      CUSTOMER_SUPPORT,
      CUSTOMER_SUPPORT_ANALYST,
      OPERATIONS,
      COMMERCIAL,
      SUPER_ADMIN,
      TECH,
      OPERATIONS_SUPERVISOR,
    ],
    component: ClientsAdjustmentScreen,
  },
  {
    title: 'MENU:EMPLOYEES',
    path: '/colaboradores',
    icon: IconUserPlus,
    onMenu: true,
    roles: [
      CLIENT,
      CORPORATE_CLIENT,
      PRODUCT,
      PRODUCT_ANALYST,
      OPERATIONS_ANALYST,
      CLIENT_ANALYST,
      CUSTOMER_SUPPORT,
      CUSTOMER_SUPPORT_ANALYST,
      OPERATIONS,
      COMMERCIAL,
      SUPER_ADMIN,
      TECH,
      OPERATIONS_SUPERVISOR,
    ],
    component: EmployeesListScreen,
  },
  {
    title: 'MENU:BALANCE',
    path: '/saldo',
    icon: IconCash,
    onMenu: true,
    roles: [CLIENT, CORPORATE_CLIENT, CLIENT_ANALYST],
    component: MyBalance,
  },
  {
    title: 'MENU:CONSUMPTION:TITLE',
    icon: IconFileInvoice,
    onMenu: true,
    roles: [
      CLIENT,
      CORPORATE_CLIENT,
      CLIENT_ANALYST,
      OPERATIONS,
      COMMERCIAL,
      OPERATIONS_SUPERVISOR,
      CUSTOMER_SUPPORT,
    ],
    validateShowMenu: useShowMenuByCategoriesAndProduct,
    subMenus: [
      {
        title: 'MENU:CONSOLIDATED_DISPERSION:TITLE',
        path: '/dispersiones-consolidadas',
        icon: IconFileInvoice,
        onMenu: true,
        roles: [
          // CLIENT,
          CORPORATE_CLIENT,
          // CLIENT_ANALYST,
          OPERATIONS,
          COMMERCIAL,
          OPERATIONS_SUPERVISOR,
          CUSTOMER_SUPPORT,
        ],
        component: ConsolidatedDispersionsList,
        validateShowMenu: useIsAreasAdminBoolean,
      },
      {
        title: 'MENU:CONSUMPTION:LIST',
        path: '/consumos',
        icon: IconFileInvoice,
        onMenu: true,
        roles: [
          CLIENT,
          CORPORATE_CLIENT,
          CLIENT_ANALYST,
          OPERATIONS,
          COMMERCIAL,
          OPERATIONS_SUPERVISOR,
          CUSTOMER_SUPPORT,
        ],
        validateShowMenu: useShowMenuByCorporateProduct,
        component: ConsumptionList,
      },
      {
        title: 'MENU:CONSUMPTION:INVOICES',
        path: '/comprobantes',
        icon: IconFileInvoice,
        onMenu: true,
        roles: [
          CLIENT,
          CORPORATE_CLIENT,
          CLIENT_ANALYST,
          OPERATIONS,
          COMMERCIAL,
          OPERATIONS_SUPERVISOR,
          CUSTOMER_SUPPORT,
        ],
        validateShowMenu: useShowMenuByCorporateProduct,
        component: Invoices,
      },
      {
        title: 'MENU:CONSUMPTION_BY_CATEGORY',
        path: '/consumos/reportes-rubro',
        icon: IconClipboardData,
        onMenu: true,
        roles: [CLIENT, CORPORATE_CLIENT],
        validateShowMenu: useShowMenuByCategories,
        component: ConsumptionByCategory,
      },
      {
        title: 'MENU:CONSUMPTION_BY_COMMERCE',
        path: '/consumos/reportes-comercio',
        icon: IconClipboardData,
        onMenu: true,
        roles: [CLIENT, CORPORATE_CLIENT],
        validateShowMenu: useShowMenuByCategories,
        component: ConsumptionByCommerce,
      },
    ],
  },
  {
    title: 'MENU:DISPERSIONS:TITLE',
    path: '/dispersiones',
    icon: IconPremiumRights,
    onMenu: true,
    roles: [
      OPERATIONS,
      COMMERCIAL,
      OPERATIONS_SUPERVISOR,
      CLIENT,
      CORPORATE_CLIENT,
      SUPER_ADMIN,
      CUSTOMER_SUPPORT,
    ],
    subMenus: [
      {
        title: 'MENU:DISPERSIONS:FILE_DISPERSION',
        path: '/dispersiones/subir-archivo',
        icon: IconUpload,
        onMenu: true,
        roles: [
          OPERATIONS,
          COMMERCIAL,
          OPERATIONS_SUPERVISOR,
          CLIENT,
          CORPORATE_CLIENT,
          SUPER_ADMIN,
        ],
        component: FileDispersionsScreen,
      },
      {
        title: 'MENU:DISPERSIONS:MY_DISPERSIONS',
        path: '/dispersiones/mis-dispersiones',
        icon: IconReportMoney,
        onMenu: true,
        roles: [
          OPERATIONS,
          COMMERCIAL,
          OPERATIONS_SUPERVISOR,
          CLIENT,
          CORPORATE_CLIENT,
          SUPER_ADMIN,
          CUSTOMER_SUPPORT,
        ],
        component: MyDispersionsScreen,
      },
      {
        title: 'MENU:DISPERSIONS:MY_DISPERSIONS',
        path: '/dispersiones/mis-dispersiones/:dispersionId',
        onMenu: false,
        roles: [
          OPERATIONS,
          COMMERCIAL,
          OPERATIONS_SUPERVISOR,
          CLIENT,
          CORPORATE_CLIENT,
          SUPER_ADMIN,
          CUSTOMER_SUPPORT,
        ],
        component: DispersionDetails,
      },
      {
        title: 'MENU:DISPERSIONS:PENDING',
        path: '/dispersiones/gestion-pendientes',
        icon: IconClipboardData,
        onMenu: true,
        roles: [OPERATIONS_SUPERVISOR],
        component: PendingDispersionsScreen,
      },
      {
        title: 'MENU:DISPERSIONS:PENDING',
        path: '/dispersiones/gestion-pendientes/:id',
        onMenu: false,
        roles: [OPERATIONS_SUPERVISOR],
        component: PendingDispersionDetailScreen,
      },
    ],
  },
  {
    title: 'MENU:PROSPECTS:ACCOUNT',
    path: '/alta-de-cuenta',
    icon: IconForms,
    onMenu: true,
    roles: [CLIENT, CORPORATE_CLIENT],
    component: ProspectCreationScreen,
  },
  {
    title: 'MENU:PROSPECTS:TITLE',
    path: '/prealta/rapida',
    icon: IconUsersPlus,
    onMenu: true,
    roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR, SUPER_ADMIN],
    component: ProspectCreationScreen,
    subMenus: [
      {
        title: 'MENU:PROSPECTS:QUICK_CREATION',
        path: '/prealta/rapida',
        icon: IconForms,
        onMenu: true,
        roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR, SUPER_ADMIN],
        component: ProspectCreationScreen,
      },
      {
        title: 'MENU:PROSPECTS:UPLOAD_FILE',
        path: '/prealta/subir-archivo',
        icon: IconUpload,
        onMenu: true,
        roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR, SUPER_ADMIN],
        component: ProspectUploadScreen,
      },
      {
        title: 'MENU:PROSPECTS:SEND_EMAIL',
        path: '/prealta/enviar-email',
        icon: IconMailForward,
        onMenu: true,
        roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR, SUPER_ADMIN],
        component: ProspectSendEmail,
      },
      {
        title: 'MENU:PROSPECTS:PENDING',
        path: '/prealta/gestion-pendientes',
        icon: IconClipboardData,
        onMenu: true,
        roles: [OPERATIONS, OPERATIONS_SUPERVISOR],
        component: PendingProspectsScreen,
      },
      {
        title: 'MENU:PROSPECTS:PENDING',
        path: '/prealta/gestion-pendientes/:prospectId',
        onMenu: false,
        roles: [OPERATIONS, OPERATIONS_SUPERVISOR],
        component: PendingProspectDetailScreen,
      },
    ],
  },
  // ! Hide this section for next release, should be displayed when the data team completes the power bi boards
  /*   {
    title: 'MENU:REPORTS',
    path: '/reportes',
    icon: IconClipboardData,
    onMenu: true,
    roles: [CLIENT],
    component: ReportDetails,
  }, */
  {
    path: '/reportes-operaciones',
    onMenu: false,
    roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR, SUPER_ADMIN],
    component: ReportDetails,
  },
  {
    path: '/detalle-cliente/:username',
    onMenu: false,
    roles: [
      CLIENT,
      CORPORATE_CLIENT,
      PRODUCT,
      PRODUCT_ANALYST,
      OPERATIONS_ANALYST,
      CLIENT_ANALYST,
      CUSTOMER_SUPPORT,
      CUSTOMER_SUPPORT_ANALYST,
      OPERATIONS,
      COMMERCIAL,
      SUPER_ADMIN,
      TECH,
      OPERATIONS_SUPERVISOR,
    ],
    component: EmployeeDetailsScreen,
  },
  {
    path: '/movimiento/:id',
    onMenu: false,
    roles: [
      CLIENT,
      CORPORATE_CLIENT,
      PRODUCT,
      PRODUCT_ANALYST,
      OPERATIONS_ANALYST,
      CLIENT_ANALYST,
      CUSTOMER_SUPPORT,
      CUSTOMER_SUPPORT_ANALYST,
      OPERATIONS,
      COMMERCIAL,
      SUPER_ADMIN,
      TECH,
      OPERATIONS_SUPERVISOR,
    ],
    component: MovementDetails,
  },
  {
    title: 'MENU:TRANSFER_RECEIPT:TITLE',
    path: '/recibo-de-transferencia',
    roles: [OPERATIONS, CLIENT, CORPORATE_CLIENT, SUPER_ADMIN],
    onMenu: true,
    icon: IconReceipt2,
    component: TransferReceiptScreen,
    validateShowMenu: useIsAreasAdminBoolean,
  },
  {
    title: 'MENU:CURRENCY_RATE',
    path: '/cotizaciones',
    roles: [OPERATIONS, COMMERCIAL, OPERATIONS_ANALYST, OPERATIONS_SUPERVISOR, SUPER_ADMIN],
    onMenu: true,
    icon: IconFileDollar,
    component: ExchangeRatesScreen,
  },
  {
    title: 'MENU:COMMERCES',
    path: '/administrador-comercios',
    roles: [OPERATIONS, COMMERCIAL, OPERATIONS_ANALYST, OPERATIONS_SUPERVISOR, SUPER_ADMIN],
    onMenu: true,
    icon: IconBuildingStore,
    component: CommercesAdminScreen,
  },
  {
    path: '/*',
    roles: ALL_ROLES,
    onMenu: false,
    component: HomeScreen, //TODO: Screen 404
  },
  {
    title: 'CLIENTS:CREATE_CLIENT_BUTTON',
    path: '/altas/cliente',
    icon: IconUsersPlus,
    roles: [OPERATIONS, COMMERCIAL, OPERATIONS_ANALYST, OPERATIONS_SUPERVISOR],
    onMenu: true,
    component: AddClient,
    subMenus: [
      {
        title: 'COMMON:COMPANY',
        path: '/altas/razon-social',
        icon: IconBuilding,
        onMenu: true,
        roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR],
        component: AddClient,
      },
      {
        title: 'MENU:PENDING_CUSTOMERS:TITLE',
        path: '/altas/gestion-razones-sociales',
        icon: IconClipboardData,
        onMenu: true,
        roles: [OPERATIONS, OPERATIONS_SUPERVISOR],
        component: PendingCustomersScreen,
      },
      {
        title: 'MENU:ADD_SEGMENT',
        path: '/altas/segmentos',
        icon: IconTags,
        onMenu: true,
        roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR],
        component: AddSegments,
      },
      {
        title: 'EMPLOYEES:DETAIL:PRODUCTS',
        path: '/altas/productos',
        icon: IconListDetails,
        onMenu: true,
        roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR],
        component: AddCustomerProduct,
      },
    ],
  },
  {
    title: 'PENDING_CUSTOMERS:DETAIL:TITLE',
    path: '/altas/gestion-razones-sociales/:id',
    onMenu: false,
    roles: [OPERATIONS_SUPERVISOR, OPERATIONS],
    component: PendingCustomerDetailScreen,
  },
  {
    title: 'MENU:USERS_MANAGEMENT:TITLE',
    path: '/gestion-de-usuarios',
    icon: IconUserPlus,
    roles: [
      OPERATIONS,
      COMMERCIAL,
      OPERATIONS_ANALYST,
      OPERATIONS_SUPERVISOR,
      SUPER_ADMIN,
      INFRA,
      CUSTOMER_SUPPORT,
    ],
    onMenu: true,
    component: UsersManagment,
    subMenus: [
      {
        title: 'MENU:USERS_MANAGEMENT:LIST',
        path: '/gestion-de-usuarios',
        icon: IconUserPlus,
        roles: [
          OPERATIONS,
          COMMERCIAL,
          OPERATIONS_ANALYST,
          OPERATIONS_SUPERVISOR,
          SUPER_ADMIN,
          INFRA,
          CUSTOMER_SUPPORT,
        ],
        onMenu: true,
        component: UsersManagment,
      },
      {
        title: 'MENU:USERS_MANAGEMENT:CREATE',
        path: '/agregar-usuario',
        icon: IconUserPlus,
        roles: [OPERATIONS, COMMERCIAL, OPERATIONS_ANALYST, CUSTOMER_SUPPORT],
        onMenu: true,
        component: CreateUserFormScreen,
      },
    ],
  },
  {
    title: 'MENU:LIMITS_MANAGEMENT:TITLE',
    path: '/gestion-de-limites',
    icon: IconMathMaxMin,
    roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR],
    onMenu: true,
    component: LimitsManagement,
  },
  {
    title: 'MENU:LIMITS_MANAGEMENT:TITLE',
    path: '/gestion-de-limites/:id',
    icon: IconMathMaxMin,
    roles: [OPERATIONS, COMMERCIAL, OPERATIONS_SUPERVISOR],
    onMenu: false,
    component: LimitDetailScreen,
  },
  {
    title: 'MENU:GIFT_CARDS:TITLE',
    icon: IconGiftCard,
    roles: [OPERATIONS, OPERATIONS_SUPERVISOR, COMMERCIAL],
    onMenu: true,
    component: NamelessCardsScreen,
    subMenus: [
      {
        title: 'MENU:GIFT_CARDS:TITLE_UPLOAD',
        path: '/tarjetas-innominadas',
        icon: IconUpload,
        roles: [OPERATIONS, OPERATIONS_SUPERVISOR, COMMERCIAL],
        onMenu: true,
        component: NamelessCardsScreen,
      },
      {
        title: 'MENU:GIFT_CARDS:TITLE_LIST',
        path: '/tarjetas-innominadas/mis-altas',
        icon: IconList,
        roles: [OPERATIONS, OPERATIONS_SUPERVISOR, COMMERCIAL],
        onMenu: true,
        component: NamelessCardsListScreen,
      },
      {
        title: 'MENU:GIFT_CARDS:TITLE_LIST',
        path: '/tarjetas-innominadas/mis-altas/:dispersionId',
        roles: [OPERATIONS, OPERATIONS_SUPERVISOR, COMMERCIAL],
        onMenu: false,
        component: NamelessCardBulkDetailScreen,
      },
    ],
  },
];

export default screens;
